import { useEffect, useState } from 'react';

import { RouterProvider } from 'react-router';

import { initI18n } from '@/shared/i18n';
import { httpClient } from '@/shared/services/api/http-client';
import { TooltipProvider } from '@/shared/ui/Popover';

import { Splash } from '@/app/pages/SystemPages';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { RealtimeProvider } from '@/app/providers/RealtimeProvider';
import { createRouter } from '@/app/router';
import { usePreferencesStore } from '@/stores/preferences.store';
import { useSessionStore } from '@/stores/session.store';
import { watchSystemTheme } from '@/stores/theme.store';

const router = createRouter();

/**
 * La racine : les fournisseurs, puis le routeur, une fois la langue, la session
 * et les préférences relues sur l'appareil. Ouvrir en français pour sauter en
 * malgache au rendu suivant se verrait ; l'écran de lancement ne dure que le
 * temps d'une lecture locale (la session connue s'affiche sans attendre le réseau).
 */
export function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Une session perdue en cours d'usage (jeton révoqué, compte suspendu)
    // vide l'état : les gardes renvoient alors vers l'accueil public.
    httpClient.onSessionLost(() => {
      void useSessionStore.getState().signOut();
    });
    const stopTheme = watchSystemTheme();
    void Promise.all([
      initI18n(),
      useSessionStore.getState().restore(),
      usePreferencesStore.getState().hydrate(),
    ]).finally(() => setReady(true));
    return stopTheme;
  }, []);

  if (!ready) {
    return <Splash />;
  }

  return (
    <QueryProvider>
      <RealtimeProvider>
        <TooltipProvider delayDuration={350}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </RealtimeProvider>
    </QueryProvider>
  );
}
